import React from 'react';
import ReactHtmlParser from 'react-html-parser';

export interface TopicDescriptionProps {
  description: string;
  isAi: boolean;
  topic: string;
}
const OPEN_AI_INACCURACY_REPORT_LINK =
  'https://docs.google.com/forms/d/e/1FAIpQLSe4Q_05NKBywoWXJ2BMwylz6jqLB7s7deoLQlCOrtPbB0IdvQ/viewform';
const OPEN_AI_INACCURACY_COPY = `<strong> AI generated - <a href="${OPEN_AI_INACCURACY_REPORT_LINK}"><u>report inaccuracies</u>.</strong>`;

const TopicDescription = ({ description, isAi, topic }: TopicDescriptionProps) => {
  return (
    <p id="entity-custom-blurb" className="m-0">
      {description ? (
        <>
          {ReactHtmlParser(description)}
          {isAi ? ReactHtmlParser(OPEN_AI_INACCURACY_COPY) : ''}
        </>
      ) : (
        <>
          The Information’s in-depth reporting about <strong>{topic}</strong>.<br></br>
          Follow this topic to get the latest updates from The Information reporters and
          subscribers.
        </>
      )}
    </p>
  );
};

export default TopicDescription;
